import { Injectable } from '@angular/core';
import { EventTrackingService } from '@mpt-fo/common/core/services/event-tracking.service';
import { initializeDatalayer } from '@mpt-fo/common/shared/models/data.layer.model';
import { AnalyticsPayload, EventPayload, isValidKycLevelEvent } from './onboarding-analytics.model';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class OnboardingAnalyticsService {
    constructor(private readonly eventTrackingService: EventTrackingService) {}

    private getBasePayload() {
        const basePayload = initializeDatalayer('');
        basePayload.phone_number = basePayload.phone_number || localStorage.getItem('phone_number');
        return basePayload;
    }

    private getPayload({ event, eventData, keysToInclude }: EventPayload): AnalyticsPayload {
        let basePayload = this.getBasePayload();
        const getNestedValue = (obj: any, path: string) => {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        };

        const filteredEventData = keysToInclude
            ? keysToInclude.reduce((acc, keyWithAlias) => {
                  const [key, alias] = keyWithAlias.split('|').map((s) => s.trim());
                  const value = getNestedValue(eventData, key);
                  if (value !== undefined) {
                      const newKey = alias || key.split('.').pop() || key;
                      acc[newKey] = value;
                  }
                  return acc;
              }, {} as Record<string, unknown>)
            : eventData;

        return { ...basePayload, ...filteredEventData, event };
    }

    private getBaseErrorPayload(error: HttpErrorResponse) {
        const getMixpanelMessage = StringHelper.getMixpanelErrorMessage(error);
        return {
            api_error_message: getMixpanelMessage,
            api_error_code: error?.status,
        };
    }

    trackKycLevelEvent(eventPayload: EventPayload) {
        const { event, error, eventData = {}, keysToInclude = [] } = eventPayload;
        if (!isValidKycLevelEvent(event)) return;
        let payload = this.getPayload({ event, eventData, keysToInclude });
        if (error) {
            const errorPayload = this.getBaseErrorPayload(error);
            payload = { ...payload, ...errorPayload };
        }
        this.eventTrackingService.trackEvent(event, payload);
    }
}
